import { useMutation } from "@tanstack/react-query";
import clienteAxios from "../../helpers/clienteAxios";

const api = async (datos) => {
  const { data } = await clienteAxios.get("/sucursalVirtual/chatbot", datos);
  return data;
};

const useChatbot = () => {

  return useMutation(api, {
    onSuccess: (response) => {
    },
    onError: (error) => {
    
    },

  });
};

export default useChatbot;
